<template>
  <div>
    <div v-if="is_show">

      <!-- 中心图片 -->
      <div>
        <img src="../assets/S160.png" alt="" style="width: 100%;" class="responsive-image" />
      </div>

      <!-- 搜索 -->
      <div class="container">
        <div class="center">
          <div class="search-container">
            <div class="search-center">
              <!-- 搜索输入框 -->
              <el-input class="main-search-input" style="border-radius: 0px; border: transparent;" clearable
                v-model="query.keyword" placeholder="请输入公告名称、项目编号、竞价名称"></el-input>
            </div>
            <div class="search-right">
              <!-- 搜索按钮 -->
              <button @click="handle_search()" class="search-btn">搜索</button>
            </div>
          </div>
        </div>
      </div>

      <!-- 项目类型 -->
      <div class="leixin">
        <div class="containers">
          <!-- 类型选项卡 -->
          <div class="type-tabs" ref="tabsContainer">
            <div v-for="(item, index) in typeList" :key="index"
              :class="['type-item', { 'type-active': typeIndex === item.ID }]" @click="switchType(item.ID, index)">
              {{ item.TITLE }}
            </div>
          </div>
          <!-- 类型对应的内容区域 -->
          <div style="min-height: 530px;padding-bottom: 60px;" class="type-content">
            <!-- 数据表格 -->
            <el-table @row-click="row_click" v-loading="loading" :data="tableData" style="width: 100%">
              <!-- 表格列定义 -->
              <el-table-column width="150" prop="PROJECT_NUM" label="项目编号"></el-table-column>
              <el-table-column prop="TITLE" label="项目公告"></el-table-column>
              <!-- <el-table-column prop="TYPE_NAME" label="类型"></el-table-column> -->
              <el-table-column prop="BIDDING_TITLE" label="竞价名称"></el-table-column>
              <el-table-column prop="OBJ_NUM" label="标的数量"></el-table-column>
              <el-table-column prop="TYPE_NAME" label="项目类型"></el-table-column>
              <el-table-column prop="STATUS_TXT" label="项目状态"></el-table-column>
              <el-table-column width="185" prop="APPLY_END_TIME_TXT" label="报名截止时间"></el-table-column>
              <el-table-column width="185" prop="UP_END_TIME_TXT" label="提交资料截止时间"></el-table-column>
              <el-table-column prop="BIDDING_START_TIME_TXT" label="开始时间"></el-table-column>
              <el-table-column prop="BIDDING_END_TIME_TXT" label="结束时间"></el-table-column>
              <!-- 空状态提示 -->
              <el-empty slot="empty" description="暂无数据..."></el-empty>
            </el-table>

            <!-- 分页 -->
            <div style="padding-top: 30px;" class="boxc">
              <el-pagination @current-change="current_change" :current-page="query.page" :total="total"
                :page-size="query.limit" class="custom-pagination" background layout="prev, pager, next">
              </el-pagination>
            </div>
          </div>
        </div>
      </div>

      <!-- 项目公告 -->
      <div v-if="false" style="margin-top: 20px;" class="container">
        <div style="display: flex;align-items: center;">
          <img style="width: 35px;height: 20px;margin-right: 8px;" src="@/assets/xmgg.png" alt="">
          <h1 style="margin: 5px 0;">项目公告</h1>
        </div>
      </div>
      <div v-if="false" class="gonggao">
        <div class="container">
          <div class="notice-wrap">
            <!-- 左侧公告列表 -->
            <div class="notice-left">
              <div class="notice-title">
                <div class="title-text">项目资料通知</div>
                <!-- 查看更多按钮 -->
                <div @click="handle_all()" class="more">查看更多 ></div>
              </div>
              <div class="notice-content">
                <!-- 公告项，最多显示10条 -->
                <div v-if="index <= 9" class="notice-item" @click="handle_jup(i)" v-for="(i, index) in ggaoData"
                  :key="i.ID">
                  <div class="yuan"></div> <!-- 小圆点装饰 -->
                  <span>{{ i.TITLE }}</span> <!-- 公告标题 -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 强制修改密码提示弹窗 -->
      <el-dialog title="提示" center :show-close="false" :visible.sync="dialogVisible" width="380px"
        :before-close="handleDialogBeforeClose">
        <div class="dialog_content">
          <div>您的账号已超过90天未修改密码</div>
          <div>为了账号安全</div>
          <div>需强制 <span style="color: #d32737;">修改密码</span> </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <!-- 跳转修改密码页面按钮 -->
          <el-button type="primary" @click="go_path()">修改密码</el-button>
        </span>
      </el-dialog>
    </div>

    <div v-else>
      <ProJects @handleClick="handleClick()" @is_back="is_back()" ref="ProJects"></ProJects>
    </div>

  </div>
</template>

<script>
import ProJects from './ProJects.vue'
export default {
  components: {
    ProJects
  },
  data() {
    return {
      is_show: true,
      ggaoData: [], // 项目公告（通知）数据列表
      loading: true, // 表格加载状态
      // isShow: false, // 这个变量在原始代码中被赋值但未被使用，暂时注释掉
      dialogVisible: false, // 控制强制修改密码弹窗的显示状态
      // select_value: '', // 这个变量在原始代码中被定义但未被使用，暂时注释掉
      typeList: [], // 项目类型列表
      typeIndex: 0, // 当前选中的项目类型的ID
      tableData: [], // 表格显示的数据
      userInfo: {}, // 当前用户信息
      query: { // 查询参数
        keyword: '', // 搜索关键字
        type_id: '', // 项目类型ID
        page: 1, // 当前页码
        limit: 8, // 每页显示条数
      },
      total: 0, // 数据总条数
    };
  },
  // 组件创建时执行
  async created() {
    // 并行获取用户信息和项目公告，提高初始加载速度
    this.get_user_info(); // 获取用户信息
    this.get_gong_gao(); // 获取项目公告(通知)

    // 获取项目类型，此操作完成后会触发初始列表数据的加载
    await this.get_project_type();
    // 注意: get_list() 是在 get_project_type() 内部成功获取类型后调用的
  },
  methods: {
    handleClick(index, e, i) {
      console.log(index, e, i, '---handleClickhandleClick-->');
      this.$emit('handleClick', 1, 12, i);
    },
    is_back() {
      this.is_show = true
      console.log('is_back----->');
    },
    /**
     * @description 表格行点击事件处理
     * @param {object} row 被点击行的数据对象
     */
    row_click(row) {
      console.log(row, '----->');
      this.is_show = false
      this.$nextTick(() => {
        this.$refs.ProJects.handleClick(row)
      })
      // // 将项目ID存入localStorage，供其他页面或组件使用
      // localStorage.setItem('get_info_id', row.ID);
      // // 使用 $nextTick 确保DOM更新后再触发事件
      // this.$nextTick(() => {
      //   // 向父组件或其他监听者发送 'handleClick' 事件
      //   // 参数: 1 (标识操作类型), '12' (标识具体场景或来源), row (行数据)
      //   this.$emit('handleClick', 1, '12', row);
      // });
    },

    /**
     * @description 分页页码改变事件处理
     * @param {number} page 当前页码
     */
    current_change(page) {
      // 更新查询参数中的页码
      this.query.page = page;
      // 重新获取列表数据
      this.get_list();
    },

    /**
     * @description 项目公告（通知）列表项点击事件处理
     * @param {object} item 被点击的公告项数据对象
     */
    handle_jup(item) {
      // 向父组件或其他监听者发送 'handleClick' 事件
      // 参数: 2 (标识操作类型), '11' (标识具体场景或来源), item (公告数据)
      this.$emit('handleClick', 2, '11', item);
    },

    /**
     * @description "查看更多" 公告按钮点击事件处理
     */
    handle_all() { // 原方法名 hanlde_all 有拼写错误，已修正为 handle_all
      console.log('-----> 查看所有公告');
      // 向父组件或其他监听者发送 'handleClick' 事件
      // 参数: 2 (标识操作类型，与单个公告点击相同，可能需要父组件区分)
      this.$emit('handleClick', 2);
    },

    /**
     * @description 搜索按钮点击事件处理
     */
    handle_search() {
      // 重置页码为第一页
      this.query.page = 1;
      // 根据当前关键词和类型获取列表数据
      this.get_list();
    },

    /**
     * @description 跳转到修改密码页面
     */
    go_path() {
      // 关闭弹窗
      this.dialogVisible = false;
      // 使用 Vue Router 跳转到 '/reset_passwords' 路径
      this.$router.push({ path: '/reset_passwords' });
    },

    /**
     * @description el-dialog 的 before-close 钩子 (虽然当前未使用，但保留以符合element-ui习惯)
     * @param {function} done 用于关闭 Dialog 的回调函数
     */
    handleDialogBeforeClose(done) {
      // 这里可以添加关闭前的确认逻辑等
      // console.log('Dialog before close');
      // 如果需要阻止关闭，则不调用 done()
      // 默认行为是允许关闭
      done();
    },

    /**
     * @description 获取当前登录用户信息
     */
    async get_user_info() {
      try {
        const res = await this.$http.post('/api/user/userinfo');
        if (res.data.code == 200) {
          console.log(res.data.data, '-----> 用户信息获取成功');
          this.userInfo = res.data.data;
          // 将用户信息存入 localStorage
          localStorage.setItem('user_info', JSON.stringify(res.data.data));

          // 检查是否需要强制修改密码 (IS_PWD == '1')
          // this.userInfo.IS_PWD = '1' // 测试代码，应移除
          if (this.userInfo.IS_PWD == '1') {
            this.dialogVisible = true; // 显示强制修改密码弹窗
          }
        } else {
          // 请求成功但业务失败，显示错误信息
          this.$message.error(res.data.msg);
        }
      } catch (error) {
        // 请求本身失败（网络错误等）
        console.error("获取用户信息失败:", error);
        this.$message.error('获取用户信息失败，请检查网络或联系管理员');
      }
      // console.log(res, '----->userinfo API 响应'); // 原始日志，可按需保留或移除
    },

    /**
     * @description 获取项目公告（通知）数据
     */
    async get_gong_gao() {
      try {
        const res = await this.$http.get('/api/project/get_project', {
          params: { // 使用 params 传递 GET 请求参数
            page: 1,
            limit: 10, // 只需要前10条用于首页显示
          }
        });
        if (res.data.code == 200) {
          this.ggaoData = res.data.data.data; // 存储公告数据
        } else {
          this.$message.error(res.data.msg);
        }
      } catch (error) {
        console.error("获取项目公告失败:", error);
        this.$message.error('获取项目公告失败');
      }
    },

    /**
     * @description 获取项目列表数据（根据当前查询条件）
     */
    async get_list() {
      this.loading = true; // 开始加载，显示loading状态
      try {
        const res = await this.$http.get('/api/project/get_home', {
          params: this.query // 传递查询参数
        });
        if (res.data.code == 200) {
          this.tableData = res.data.data.data; // 更新表格数据
          this.total = res.data.data.total; // 更新总条数
          // this.query.page = res.data.data.current_page; // 后端返回了当前页，可以用于校准，但通常由前端维护current_change更新
        } else {
          this.$message.error(res.data.msg); // 显示错误信息
          this.tableData = []; // 清空数据
          this.total = 0; // 重置总数
        }
      } catch (error) {
        console.error("获取项目列表失败:", error);
        this.$message.error('获取项目列表失败');
        this.tableData = []; // 清空数据
        this.total = 0; // 重置总数
      } finally {
        this.loading = false; // 加载结束，隐藏loading状态
      }
    },

    /**
     * @description 获取项目类型列表
     */
    async get_project_type() {
      try {
        const res = await this.$http.post('/api/common/get_project_type', {}); // POST请求，如果不需要body，传空对象
        if (res.data.code == 200) {
          let obj = {
            ID: '',
            TITLE: "全部"
          }
          this.typeList = res.data.data; // 存储类型列表
          if (this.typeList && this.typeList.length > 0) {
            // 默认选中第一个类型
            // 更新查询参数中的类型ID
            this.typeList.unshift(obj); // 添加单个元素
            this.typeIndex = this.typeList[0].ID;

            this.query.type_id = this.typeIndex;
            // 获取到类型后，加载对应类型的列表数据
            await this.get_list(); // 确保在获取列表完成后再结束此方法
          } else {
            // 如果没有类型数据，也尝试获取一次列表（可能后端支持无类型查询）
            console.warn("项目类型列表为空，尝试加载默认列表");
            this.query.type_id = ''; // 清空类型ID
            await this.get_list();
          }
          // this.isShow = true; // 这个变量未使用，注释掉
        } else {
          this.$message.error(res.data.msg);
        }
      } catch (error) {
        console.error("获取项目类型失败:", error);
        this.$message.error('获取项目类型失败');
        // 即使类型获取失败，也尝试加载一次列表（无类型筛选）
        this.query.type_id = '';
        await this.get_list();
      }
    },

    /**
     * @description 切换项目类型选项卡
     * @param {number | string} id 被选中的项目类型的ID
     */
    switchType(id, index) {
      if (this.typeIndex === id) return; // 如果点击的是当前已选中的类型，则不执行任何操作

      this.loading = true; // 开始加载新类型的数据
      this.typeIndex = id; // 更新当前选中的类型ID
      this.query.type_id = this.typeIndex; // 更新查询参数中的类型ID
      this.query.page = 1; // 切换类型时，重置页码到第一页
      this.get_list(); // 获取新类型对应的列表数据

      // 自动滚动逻辑
      this.$nextTick(() => {
        const container = this.$refs.tabsContainer;
        const item = container.children[index];

        // 计算需要滚动的距离（让点击项尽量居中）
        const scrollLeft = item.offsetLeft - (container.offsetWidth / 2) + (item.offsetWidth / 2);

        // 平滑滚动
        container.scrollTo({
          left: scrollLeft,
          behavior: 'smooth'
        });
      });

    },
  },
};
</script>


<style lang="scss" scoped>
// 变量定义
$primary-color: #c31424;
$border-color: #eee;
$text-color: #666;
$bg-color: #f5f5f5;
$container-width: 1200px;

.custom-pagination ::v-deep .el-pager .number {
  border-radius: 50% !important;
}

body {
  padding: 0;
}

.logo-img {
  width: 100px;
  height: 40px;
  background-color: #808080;
}

.nav-menu {
  display: flex;
  gap: 30px;
  margin-left: 0;
}

.container {
  width: $container-width;
  height: 100%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.containers {
  width: $container-width;
  height: 100%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: space-between;

  .type-tabs {
    background-color: #f4f4f4;
    // overflow-x: auto;
    /* 自动显示滚动条 */
    display: flex;
    scrollbar-width: thin;
    /* Firefox */
    scrollbar-color: #ccc transparent;
    /* Firefox */
    // padding-bottom: 2px;
    box-sizing: border-box;
    /* 预留滚动条空间 */
    white-space: nowrap;
    /* 防止换行 */
  }

  /* Chrome/Safari/Edge 滚动条样式 */
  .type-tabs::-webkit-scrollbar {
    height: 4px;
    background-color: transparent;
  }

  .type-tabs::-webkit-scrollbar-thumb {
    background-color: #ccc;
    border-radius: 2px;
  }

  // .type-item {
  //   padding: 8px 16px;
  //   cursor: pointer;
  //   flex-shrink: 0;
  //   /* 禁止缩小 */
  // }

  // .type-active {
  //   color: #1890ff;
  //   font-weight: bold;
  // }
}

.center {
  width: 100%;
  display: flex;
  justify-content: center;
}

.search {
  &-container {
    width: 80%;
    display: flex;
    margin: 20px 0;
    border: 2px solid $primary-color;
    border-radius: 4px;
  }

  &-left {
    width: 120px;
  }

  &-select {
    width: 100%;
    height: 40px;
    border: none;
    outline: none;
    padding: 0 10px;
    border-right: 1px solid $border-color;
    cursor: pointer;
  }

  &-center {
    flex: 1;

    >>>.el-input__inner:focus {
      border-color: transparent !important;
    }
  }

  &-right {
    width: 100px;
  }

  &-btn {
    width: 100%;
    height: 40px;
    border: none;
    background: $primary-color;
    color: white;
    cursor: pointer;
    font-size: 16px;

    &:hover {
      opacity: 0.9;
    }
  }
}

.main-search-input {
  border: none;
  outline: none;

  &.is-focused {
    border-color: transparent; // 获得焦点时的边框颜色
  }

  ::v-deep .el-input__inner {
    border: transparent; // 设置边框颜色

    &:focus {
      border-color: transparent; // 获得焦点时的边框颜色
    }
  }
}

.leixin {
  width: 100%;
  margin-top: 20px;
}

.type {
  &-tabs {
    width: 100%;
    display: flex;
    border-radius: 4px 4px 0 0;
    // height: 75.2px;

  }

  &-item {
    width: 16.666666666666666666666666666%;
    max-width: 250px;
    height: 60px;
    cursor: pointer;
    transition: all 0.3s;
    display: flex;
    justify-content: center;
    align-items: center;
    background: $bg-color;
  }

  &-active {
    background-image: url("../assets/R22.png");
    background-size: 100% 100%;
    color: white;
    background-color: #fff;
  }

  &-content {
    width: 100%;
    margin-top: 20px;
    border-radius: 0px 0px 10px 10px;
    border: 2px solid #EDEEF1;
    position: relative;
  }

  &-table {
    width: 100%;
    border-collapse: collapse;

    th,
    td {
      padding: 12px;
      text-align: left;
      border-bottom: 1px solid $border-color;
    }

    th {
      background: $bg-color;
      font-weight: normal;
    }

    tr:hover {
      background: #f9f9f9;
    }
  }
}

.boxc {
  margin-top: -12px;
  display: flex;
  justify-content: center;
  width: 100%;
  position: absolute;
  bottom: 10px;
}

.gonggao {
  margin-top: 20px;
}

.notice {
  &-wrap {
    width: 100%;
    display: flex;
    gap: 20px;
  }

  &-left,
  &-right {
    flex: 1;
    background: #fff;
    border-radius: 4px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);
  }

  &-title {
    height: 50px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid $border-color;
    padding-right: 20px;
  }

  &-item {
    display: flex;
    align-items: center;
    padding: 12px 20px;
    cursor: pointer;
    transition: all 0.3s;

    &:hover {
      background: $bg-color;
    }

    span {
      color: $text-color;
    }
  }
}

.title-text {
  width: 200px;
  height: 100%;
  background-color: $primary-color;
  font-size: 16px;
  font-weight: bold;
  border-radius: 10px 10px 0 0;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
}

.more {
  color: #999;
  font-size: 14px;
  cursor: pointer;
}

.yuan {
  width: 10px;
  height: 10px;
  background-color: #d8d8d8;
  border-radius: 30px;
  margin-right: 5px;
}

.dibu {
  margin-top: 20px;
  background: #fff;
  padding: 20px 0;
}

.logoleft {
  display: flex;
  align-items: center;
}

.footer-logo {
  width: 200px;
}

.dialog_content {
  height: 120px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 18px;
  line-height: 30px;
}

.notice-content {
  min-height: 200px;
}
</style>